import httpClient from "./httpClient";

export async function getLegalPage(slug, lang) {
  const { data } = await httpClient.get(`/content/pages/${encodeURIComponent(slug)}`, {
    params: lang ? { lang } : undefined,
  });
  return data.page;
}
